import { render } from "./TermFollowChip.vue?vue&type=template&id=ca6b6b50"
import script from "./TermFollowChip.vue?vue&type=script&lang=js"
export * from "./TermFollowChip.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__